import CampaignModel from "./CampaignModel";
import ContentModel from "./ContentModel";
import TagsModel from "./TagsModel";

export default class ContextModel {
  public content?: ContentModel | null = null;
  public tags: TagsModel[] = [];
  public campaign?: CampaignModel | null = null;
}
